export default {
  namespaced: true,
  state: () => ({
    map: {}
  }),
  getters: {
    map: state => state.map
  },
  mutations: {
    map (state, list) {
      state.map = Object.freeze(list.reduce((map, relatedFactor) => {
        let {factorId, relatedFactorId} = relatedFactor
        let tmpRelatedFactor1 = map[factorId]
        let data = Object.freeze({
          relatedLow: relatedFactor.relatedLow,
          relatedHigh: relatedFactor.relatedHigh
        })

        if (!tmpRelatedFactor1) {
          tmpRelatedFactor1 = map[factorId] = {}
        }

        tmpRelatedFactor1[relatedFactorId] = data

        // let tmpRelatedFactor2 = map[relatedFactorId]

        // if (tmpRelatedFactor2) {
        //   if (tmpRelatedFactor2[factorId]) {
        //     return map
        //   }
        // } else {
        //   tmpRelatedFactor2 = map[relatedFactorId] = {}
        // }
        //
        // tmpRelatedFactor2[factorId] = data

        return map
      }, {}))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/RelatedFactor.js